/**
 * Contact - Exact replica of original contact page with HTML-like API
 * Preserves all original styling and responsive behavior
 */

import React from 'react'
import { Box, Container, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import MainCard from '../../MainCard/MainCard'

interface ContactProps {
	title?: string
	highlightedWord?: string
	linkText?: string
	linkHref?: string
	image?: string
	imageAlt?: string
}

const Contact: React.FC<ContactProps> = ({
	title = 'Contact us about',
	highlightedWord = 'ASTA',
	linkText = 'Send us an email',
	linkHref = 'mailto:info@bpsconsulting.com?subject=ASTA%20information%20request',
	image = 'assets/images/contact/worldMap.png',
	imageAlt = 'Contact map'
}) => {
	const theme = useTheme()
	const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'))
	const matchDownMD = useMediaQuery(theme.breakpoints.down('md'))

	const imageSize = {
		width: matchDownMD ? 320 : matchDownLG ? 500 : 600,
		height: matchDownMD ? 217 : matchDownLG ? 340 : 410
	}

	return (
		<Grid container spacing={12} justifyContent="center" alignItems="center" sx={{ mb: 12 }}>
			<Grid item xs={12}>
				<MainCard
					sx={{
						bgcolor: theme.palette.mode === 'dark' ? theme.palette.grey.A700 : theme.palette.grey[100],
						border: 'transparent',
						borderRadius: 0,
						m: 0,
						height: { xs: '100%', sm: 280, md: 380, lg: 480 }
					}}
				>
					<Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
						<Stack
							direction={{ xs: 'column', sm: 'row' }}
							justifyContent="space-around"
							alignItems="center"
							spacing={{ xs: 0, sm: 3 }}
						>
							<Box
								sx={{
									width: {
										xs: '100%',
										sm: 252,
										md: 360,
										lg: 436
									},
									pt: 6,
									textAlign: { xs: 'center', sm: 'left' }
								}}
							>
								<Stack spacing={1}>
									<Typography
										variant="h2"
										sx={{
											color: theme.palette.mode === 'dark' ? theme.palette.custom.light : 'black'
										}}
									>
										{title}{' '}
										<Typography variant="h2" component="span" color="primary">
											{highlightedWord}
										</Typography>
									</Typography>
									<Typography color="textSecondary">
										<a href={linkHref}>{linkText}</a>
									</Typography>
								</Stack>
							</Box>
							<Box
								sx={{
									background: theme.palette.mode === 'dark' ? theme.palette.grey.A700 : theme.palette.grey[100]
								}}
							>
								<img src={image} alt={imageAlt} width={imageSize.width} height={imageSize.height} />
							</Box>
						</Stack>
					</Container>
				</MainCard>
			</Grid>
		</Grid>
	)
}

export default Contact
